import {MvsCrudService} from "../../../../../core/shared/service/crud/mvs-crud.service";
import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {MenuItem} from 'primeng/api';
import {TeEditorCommunicationService} from '../../../service/te-editor-communication.service';
import {TeTemplateArtefactVariableLinkDto} from '../../../model/dto/entity/te-template-artefact-variable-link.dto';
import {TeTeTemplateArtefactDto} from '../../../model/dto/entity/te-template-artefact.dto';
import {TeArtefactLocationEnum} from '../../../enum/te-artefact-location.enum';
import {TeArtefactVariableService} from '../../../service/api/te-artefact-variable.service';
import {TeArtefactService} from '../../../service/api/te-artefact.service';
import {TeTemplateVariableService} from '../../../service/api/te-template-variable.service';
import {forkJoin, Observable} from 'rxjs';
import {TeTemplateVariableDto} from "../../../model/dto/entity/te-template-variable.dto";
import {TeTeArtefactVariableDto} from "../../../model/dto/entity/te-artefact-variable.dto";
import {DtoDetail} from "../../../../../core/shared/dto/dto.detail";
import {DtoList} from "../../../../../core/shared/dto/dto.list";
import {WidgetData} from "../../../../../core/shared/widget/widget-data";
import {DtoImportObjectContext} from "../../../../../core/shared/dto/dto.import.object.context";
import {MvsCoreService} from "../../../../../core/shared/service/mvs-core.service";
import {MetaService} from "../../../../../core/shared/meta/service/meta.service";
import {MvsMessageService} from "../../../../../core/shared/service/message/mvs-message.service";
import {ObjectIdentifier} from "../../../../../core/shared/basic/object-identifier";
import {WidgetFactory} from "../../../../../core/shared/widget/service/widget.factory";
import {ObjectRequestList} from "../../../../../core/shared/dto/object/request/object-request-list";
import {FilterCriteria} from "../../../../../core/shared/filter/api/filter.criteria";
import {Sorting} from "../../../../../core/shared/misc/sorting";
import {ObjectRequestComplex} from "../../../../../core/shared/dto/object/request/object-request-complex";
import {ObjectRequestComplexNode} from "../../../../../core/shared/dto/object/request/object-request-complex-node";
import {
    WidgetFunctionCallBackCreate,
    WidgetToolbarCreateInterface
} from "../../../../../core/shared/helper/widget-function-call-back-create";
import {EntityPriorityHandler} from "../../../../../core/shared/entity/entity-priority-handler";
import {ObjectRequestRelation} from "../../../../../core/shared/dto/object/request/object-request-relation";
import {
    ObjectRequestComplexRelationBindingEnum
} from "../../../../../core/shared/dto/object/request/object-request-complex-relation-binding.enum";
import {MetaDataJoinRelationEnum} from "../../../../../core/shared/meta/enum/meta-data-join-relation.enum";


@Component({
    selector: 'mvs-embedded-artefacts',
    templateUrl: './embedded-artefacts.component.html',
    styleUrls: ['./embedded-artefacts.component.scss'],
    standalone: false
})
export class EmbeddedArtefactsComponent implements OnInit, OnChanges, OnDestroy {

    busy: boolean;  // indicator whether the component is busy
    initialized: boolean; // indicator whether the component was initialized

    @Input() templateId: number;

    artefactService: TeArtefactService;
    artefactVariableService: TeArtefactVariableService;
    templateVariableService: TeTemplateVariableService;
    templateArtefactService: MvsCrudService;
    templateArtefactVariableLinkService: MvsCrudService;

    artefactLocation = [
        {value: TeArtefactLocationEnum.before, label: 'Davor', icon: 'fa-solid fa-up-to-line'},
        {value: TeArtefactLocationEnum.after, label: 'Danach', icon: 'fa-solid fa-down-from-line'},
        {value: TeArtefactLocationEnum.inline, label: 'Inline', icon: 'fa-solid fa-align-center'}
    ];
    // array for updating artefact location using icons
    artefactLocationButton = [
        {position: TeArtefactLocationEnum.before, icon: 'fa-solid fa-up-to-line'},
        {position: TeArtefactLocationEnum.after, icon: 'fa-solid fa-down-from-line'},
        {position: TeArtefactLocationEnum.inline, icon: 'fa-solid fa-align-center'}
    ];


    artefactLocationArray: number[] = [];

    selectedArtefact: DtoDetail;
    selectedLocation: number = TeArtefactLocationEnum.before;
    selectedPriority: number = 1;

    artefactsList: DtoList[] = [];
    templateVariables: DtoList;
    templateArtefacts: TeTeTemplateArtefactDto[] = [];

    templateVariablesDetail: TeTemplateVariableDto;
    templateArtefactsDetail: TeTeTemplateArtefactDto;
    artefactVariablesDetail: TeTeArtefactVariableDto;
    configurationItems: MenuItem[] | undefined;
    visible: boolean;
    dropLocation: string;
    dragNodeValue: any;
    showArtefacts: boolean[];


    widgetTemplateArtefacts: WidgetData;
    widgetTemplateArtefactVariableLink: WidgetData;

    importContextTemplate: DtoImportObjectContext;
    importContextArtefact: DtoImportObjectContext;

    constructor(
        protected coreService: MvsCoreService,
        protected metaService: MetaService,
        protected messageService: MvsMessageService,
        protected editorCommunicationService: TeEditorCommunicationService) {
    }

    ngOnInit(): void {
        this.initComponentNew();
    }

    initComponentNew() {

        this.templateArtefactService = <MvsCrudService>this.coreService.getCrudService("te.TeTemplateArtefact");

        this.importContextTemplate = DtoImportObjectContext.createFromObjectIdentifier(new ObjectIdentifier("te.TeTemplate", this.templateId));
        this.widgetTemplateArtefacts = WidgetFactory.createWidgetQl(
            "te.embedded.artefacts.list",
            "Artefakte",
            "te.TeTemplateArtefact",
            "list",
            [FilterCriteria.create("e.templateId", FilterCriteria.cOperatorEqual, this.templateId)],
            [new Sorting("e.locationEnum", true), new Sorting("e.priority", true)],
            [
                {
                    joinType: 'left',
                    type: 'entity',
                    name: 'artefact',
                    as: 'a'
                }
            ]
        )

        const fields: WidgetToolbarCreateInterface[] = [{fieldName: 'templateDtoId', fieldValue: this.templateId}];
        this.widgetTemplateArtefacts.functionCallbacks = WidgetFunctionCallBackCreate.widgetToolbarCreate(fields);

        // Load template artefacts for inline insert buttons
        this.refreshTemplateArtefactsForInline();

        this.initialized = true;
    }

    /**
     * Inline artefacts only (locationEnum === inline).
     * Only these should offer the "Inline einfügen" button since before/after
     * are resolved automatically by the backend.
     */
    get inlineArtefacts(): TeTeTemplateArtefactDto[] {
        if (!this.templateArtefacts) return [];
        return this.templateArtefacts.filter(a => a['locationEnum'] === TeArtefactLocationEnum.inline);
    }

    /**
     * Load template artefacts (simplified) for inline insert buttons.
     */
    refreshTemplateArtefactsForInline() {
        const objectRequestList = new ObjectRequestList(
            false,
            [FilterCriteria.create("template", FilterCriteria.cOperatorEqual, this.templateId)],
            [new Sorting("priority", true)]
        );

        this.templateArtefactService.list(objectRequestList).subscribe((response: DtoList<TeTeTemplateArtefactDto>) => {
            this.templateArtefacts = response.entries;
        });
    }

    handleSelectArtefact(event: ObjectIdentifier) {

        this.importContextArtefact = DtoImportObjectContext.createFromObjectIdentifier(event);

        this.widgetTemplateArtefactVariableLink = WidgetFactory.createWidgetListEntityBasicQl("te.embedded.artefacts.variable.link", "Variablen", "te.TeTemplateArtefactVariableLink", [FilterCriteria.create("e.templateArtefactId", FilterCriteria.cOperatorEqual, event.objectId)], [new Sorting("e.attributeName", true)]);
    }


    /**
     * Initialize Component.
     */
    initComponent() {

        // retrieve template variable service
        this.templateVariableService = <TeTemplateVariableService>this.coreService.getCrudService("te.TeTemplateVariable");

        // retrieve artefact variable service
        this.artefactVariableService = <TeArtefactVariableService>this.coreService.getCrudService("te.TeArtefactVariable");

        // retrieve artefact service
        this.artefactService = <TeArtefactService>this.coreService.getCrudService("te.TeArtefact");

        // retrieve template artefact service
        this.templateArtefactService = <MvsCrudService>this.coreService.getCrudService("te.TeTemplateArtefact");

        // retrieve template artefact variable link service
        this.templateArtefactVariableLinkService = <MvsCrudService>this.coreService.getCrudService("te.TeTemplateArtefactVariableLink");

        // Drag-drop removed (Phase 6/13) — variable linking is now click-based

    }


    refreshComponent() {

        this.refreshArtefacts();
        this.refreshTemplateArtefacts();
        this.handleConfigurationItems();

        this.initialized = true;
    }

    refreshArtefacts() {

        const dtoListRequest = new ObjectRequestList(false, [], [new Sorting("lastModifiedDate", false)])

        this.artefactService.list(dtoListRequest).subscribe((response: any) => {

            this.artefactsList = response;
        });
    }


    createTemplateArtefact() {

        const data: TeTeTemplateArtefactDto = new TeTeTemplateArtefactDto();

        data['templateDtoId'] = this.templateId;
        data['artefactDtoId'] = this.selectedArtefact.id;
        data['locationEnum'] = this.selectedLocation;
        data['priority'] = this.selectedPriority;


        if (!this.selectedArtefact.id) {
            this.messageService.showInfoMessage('Info', 'Bitte wählen Sie ein Artefakt aus');
            return;
        }

        if (this.selectedLocation == null) {
            this.messageService.showInfoMessage('Info', 'Bitte wählen Sie eine Position aus');
            return;
        }

        if (!this.selectedPriority) {
            this.messageService.showInfoMessage('Info', 'Bitte geben Sie eine Priorität an');
            return;
        }

        this.busy = true;

        this.templateArtefactService.create(data).subscribe(() => {

                this.busy = false;
                this.messageService.showSuccessMessage('Artefakt', 'Artefakt-Verknüpfung erstellt');
                this.refreshTemplateArtefacts();

                this.selectedArtefact = null;
                this.selectedLocation = null;
                this.selectedPriority = null;

            }, () => {

                this.busy = false;
                this.messageService.showWarningMessage('Artefakt', 'Fehler');

            }
        )

    }

    changeAttributePriority(): void {

        this.busy = true;
        let operations: any = EntityPriorityHandler.adjustPriority(this.templateArtefacts, "priority", 1000);
        let updatedArray = [];

        for (const item of operations) {
            const data: any = {};
            data['id'] = item.entry.id;
            data['priority'] = item.entry.priority;
            updatedArray.push(data);
        }

        const entryObservables: Observable<any>[] = updatedArray.map(entry => {
            this.busy = false;
            return this.templateArtefactService.update(entry);
        });

        forkJoin(entryObservables).subscribe(value => {
        });
    }

    changeArtefactPosition(artefactID: number, position_priority: number, type: string) {

        this.busy = true;
        const data: any = {};
        data['id'] = artefactID;

        if (type === 'position') {
            data['locationEnum'] = position_priority;
        }

        if (type === 'priority') {
            data['priority'] = position_priority;
        }

        this.templateArtefactService.update(data).subscribe(() => {

                this.busy = false;
                this.messageService.showSuccessMessage('Artefakt', 'Artefakt-Verknüpfung aktualisiert');
                this.refreshTemplateArtefacts();

            }, () => {

                this.busy = false;
                this.messageService.showWarningMessage('Artefakt', 'Fehler');

            }
        )

    }

    refreshTemplateArtefacts() {

        const complexSelection =
            ObjectRequestComplex.build(true, false,

                ObjectRequestComplexNode.createSimpleAttributeNode("template").addNodes(
                    ObjectRequestComplexNode.createRelationNode("templateVariables",
                        ObjectRequestRelation.createList(
                            "te.TeTemplateVariable",
                            "template",
                            null,
                            null,
                            ObjectRequestComplexRelationBindingEnum.ALL)
                    )
                ),
                ObjectRequestComplexNode.createSimpleAttributeNode("artefact").addNodes(
                    ObjectRequestComplexNode.createRelationNode("artefactVariables",
                        ObjectRequestRelation.createList(
                            "te.TeArtefactVariable",
                            "artefact",
                            null,
                            null,
                            ObjectRequestComplexRelationBindingEnum.ALL)
                    ).addNodes(
                        ObjectRequestComplexNode.createRelationNode("artefactVariableLink",
                            ObjectRequestRelation.createList(
                                "te.TeTemplateArtefactVariableLink",
                                "artefactVariable",
                                null,
                                null,
                                ObjectRequestComplexRelationBindingEnum.ANY)
                        )
                    )
                )
            );

        const objectRequestList = ObjectRequestList.createComplexRequestList(
            false,
            complexSelection,
            [FilterCriteria.create("template", FilterCriteria.cOperatorEqual, this.templateId)],
            null,
            null,
            null);


        this.templateArtefactService.list(objectRequestList).subscribe((response: DtoList<TeTeTemplateArtefactDto>) => {
            this.templateArtefacts = response.entries;
            if (!this.showArtefacts?.length) {
                this.showArtefacts = new Array(response.entries.length).fill(false);
            }
            this.artefactLocationArray = this.templateArtefacts.map(entry => {
                return entry['locationEnum'];
            });
        });
    }

    onSaveTemplateArtefactVariableLink(templateArtefacts: TeTeTemplateArtefactDto, templateVariables: TeTemplateVariableDto, artefactVariables: TeTeArtefactVariableDto, attributeName: string) {
        // function to link template variables with artefact variables

        const data: TeTemplateArtefactVariableLinkDto = new TeTemplateArtefactVariableLinkDto();


        data['templateArtefactDtoId'] = templateArtefacts.id;
        data['artefactVariableDtoId'] = artefactVariables.id;
        data['templateVariableDtoId'] = templateVariables.id;
        data['attributeName'] = attributeName;

        this.busy = true;
        if (artefactVariables['artefactVariableLink']) {
            data.id = artefactVariables['artefactVariableLink'].id;

            this.templateArtefactVariableLinkService.update(data).subscribe(
                res => {
                    this.busy = false;
                    this.messageService.showSuccessMessage('Variablen-Verknüpfung', 'Variablen-Verknüpfung aktualisiert');
                    this.refreshTemplateArtefacts();

                }, () => {

                    this.busy = false;
                    this.messageService.showWarningMessage('Variablen-Verknüpfung', 'Fehler');

                }
            )

        } else {
            this.templateArtefactVariableLinkService.create(data).subscribe(
                res => {
                    this.busy = false;
                    this.messageService.showSuccessMessage('Variablen-Verknüpfung', 'Variablen-Verknüpfung erstellt');
                    this.refreshTemplateArtefacts();
                }, () => {

                    this.busy = false;
                    this.messageService.showWarningMessage('Variablen-Verknüpfung', 'Fehler');

                }
            )
        }

    }

    onRemoveTemplateArtefactVariableLink(templateArtefactVariableLink: TeTemplateArtefactVariableLinkDto) {

        this.busy = true;
        this.templateArtefactVariableLinkService.delete(templateArtefactVariableLink.id).subscribe(
            res => {
                this.busy = false;
                this.messageService.showSuccessMessage('Variablen-Verknüpfung', 'Variablen-Verknüpfung gelöscht');
                this.refreshTemplateArtefacts();

            }, () => {

                this.busy = false;
                this.messageService.showWarningMessage('Variablen-Verknüpfung', 'Fehler');

            }
        )
    }


    private findParentNodes(value: any) {
        // to find the name/label of parent nodes
        if (value.node.parent.data.joinRelationEnum == MetaDataJoinRelationEnum.oneToMany) {
            this.messageService.showInfoMessage('Info', "Eins-zu-Viele-Beziehungen können nicht verknüpft werden");
            return;
        }
        let node = value.node;
        let nodes = [];
        const attribute = node.parent?.data?.typeId ? '.' + value.node.label : value.node.label;
        nodes.push(attribute);

        while (node.parent) {
            if (node.parent.data.typeId) {
                nodes.unshift('#' + node.parent.data.typeId);
            } else if (node.parent?.parent) {
                const attr = node.data.typeId ? node.parent.label : node.parent.label + '.';
                nodes.unshift(attr)
            }
            node = node.parent;
        }
        this.dragNodeValue = nodes.toString().replace(/,/g, '');
        this.templateVariablesDetail = node.data;
        this.onSaveTemplateArtefactVariableLink(this.templateArtefactsDetail, this.templateVariablesDetail, this.artefactVariablesDetail, this.dragNodeValue)
    }

    handleOnDrop(event: DragEvent, templateArtefacts: TeTeTemplateArtefactDto, artefactVariables: TeTeArtefactVariableDto): void {
        // assigning templateArtefacts & artefactVariables to corresponding variables
        this.templateArtefactsDetail = templateArtefacts;
        this.artefactVariablesDetail = artefactVariables;

        this.dropLocation = "dropDown";
        event.preventDefault();

    }

    /**
     * Insert artefact inline into the editor via communication service.
     * Replaces the old drag-based linking.
     */
    handleInsertArtefactInline(artefact: TeTeTemplateArtefactDto): void {
        if (artefact && artefact['artefactDtoId']) {
            const artefactName = artefact['artefactDtoName'] || 'Artefakt #' + artefact['artefactDtoId'];
            this.editorCommunicationService.insertArtefact(artefact['artefactDtoId'], artefactName);
        }
    }

    handleConfigurationItems() {

        this.configurationItems = [
            {
                label: 'Artefakt hinzufügen',
                icon: 'fa-solid fa-plus',
                command: (event: any) => this.toggleDialog()
            }

        ];
    }

    toggleDialog() {
        this.visible = true;
    }


    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        if (changes["id"]) {
            this.refreshComponent();
        }
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {

    }
}
